import { useEffect, useState } from "react";

import { Button, Input, Modal } from "@web-app/components";

type SaveOptimizationModalProps = {
  initialName?: string;
  isOpen: boolean;
  isSubmitting: boolean;
  mode: "draft" | "send";
  onClose: () => void;
  onSubmit: (name: string) => void;
};

const COPY = {
  draft: {
    cta: "Save",
    subtitle:
      "All the configuration you did will be saved in drafts files so you can reuse it anytime",
    title: "Save in Drafts",
  },
  send: {
    cta: "Save & Send",
    subtitle: "Save your workflow and send it to the providers",
    title: "Save and send to providers",
  },
};

export default function SaveOptimizationModal({
  initialName = "",
  isOpen,
  isSubmitting,
  mode,
  onClose,
  onSubmit,
}: SaveOptimizationModalProps) {
  const [name, setName] = useState(initialName);
  const copy = COPY[mode];

  useEffect(() => {
    if (isOpen) setName(initialName);
  }, [isOpen, initialName]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={copy.title}
      subtitle={copy.subtitle}
      width={460}
      actionsAlign="end"
      actions={[
        <Button key="cancel" color="light" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          onClick={() => onSubmit(name.trim())}
          disabled={!name.trim()}
          isLoading={isSubmitting}
        >
          {copy.cta}
        </Button>,
      ]}
    >
      <div className="px-4 py-3">
        <Input
          type="text"
          value={name}
          onChange={setName}
          placeholder="Set the name here"
        />
      </div>
    </Modal>
  );
}
